const _ = require('underscore');

const FLATTENED_OBJECT_KEY_DELIM = '.';

const isDate = function (v) {
    return v instanceof Date;
};

function unflattenProperty(obj, val, key, newsplit) {
    const split = newsplit || key.split(FLATTENED_OBJECT_KEY_DELIM);
    const tok = split[0];
    const nexttok = split[1];
    let inexttok;
    let itok;

    if (nexttok) {
        if (typeof obj[tok] !== 'object' || obj[tok] === null) {
            delete obj[tok];
        }
        inexttok = parseInt(nexttok);
        obj[tok] || (obj[tok] = (inexttok || inexttok === 0) ? [] : {});
        unflattenProperty(obj[tok], val, null, split.slice(1));
        if (_.isArray(obj[tok])) {
            return obj[tok] = _.compact(obj[tok]);
        }
    } else {
        itok = parseInt(tok);
        if (_.isArray(obj) && !itok && itok !== 0) {
            return;
        }
        return obj[tok] = val;
    }
}


function sortKeysFn(keys) {
    if (!keys || !keys.length) {
        return [];
    }
    return keys.sort();
}
const sortKeys = _.memoize(sortKeysFn, JSON.stringify);

function flattenPropertiesInObject(obj) {
    const ret = {};
    for (let i in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, i))
            continue;
        if ((typeof obj[i]) == 'object' && !isDate(obj[i])) {
            const flatObject = flattenPropertiesInObject(obj[i]);
            for (const x in flatObject) {
                if (!Object.prototype.hasOwnProperty.call(flatObject, x))
                    continue;
                ret[i + FLATTENED_OBJECT_KEY_DELIM + x] = flatObject[x];
            }
        } else {
            ret[i] = obj[i];
        }
    }
    return ret;
}

function unflattenPropertiesInObject(obj) {
    obj = obj == null ? {} : _.clone(obj);
    sortKeys(_.keys(obj))
        .forEach(function (key) {
            if (!Object.prototype.hasOwnProperty.call(obj, key)
                || key.indexOf(FLATTENED_OBJECT_KEY_DELIM) === -1) {
                return;
            }
            unflattenProperty(obj, obj[key], key);
            delete obj[key];
        });
    return obj;
}

function unflattenPropertiesInAllObjects(list) {
    if (list == null) {
        list = [];
    }
    return list.map(unflattenPropertiesInObject);
}

module.exports = {
    unflattenPropertiesInAllObjects,
    unflattenPropertiesInObject,
    flattenPropertiesInObject
};
